import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	IUpdateCategory,
	TCategoryType,
	IItemSubCategory,
} from 'types';
import { TVisibleForm, TTypeOfModalWindow, IInitialFormData } from './editCategoryContext';

export enum EditCategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_CATEGORY = 'CHANGE_NAME_OF_CATEGORY',
	SET_CATEGORY_TYPE = 'SET_CATEGORY_TYPE',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: EditCategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetInitialFormData {
	type: EditCategoryActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IInitialFormData;
	};
}

interface ISetAllData {
	type: EditCategoryActionTypes.SET_ALL_DATA;
	payload: {
		filePath: Nullable<string>;
		preSignedUrl: string | null;
		categoryID: string;
		initialIDSelectedCustomer: Nullable<string>;
		initialIDsSelectedRestaurant: string[];
		nameOfCategory: string;
		categoryType: Nullable<TCategoryType>;
		subcategoriesOfCategory: IItemSubCategory[];
		isRestricted: boolean;
		activationSchedule: string;
		deactivationSchedule: string;
		translations: IMenuTranslation[];
	};
}

interface IChangeLoaderStatus {
	type: EditCategoryActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: boolean;
	};
}

interface IChangeVisibleForm {
	type: EditCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TVisibleForm;
	};
}

interface ISetFileId {
	type: EditCategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: TFileId;
	};
}

interface IDeletePhoto {
	type: EditCategoryActionTypes.DELETE_PHOTO;
}

interface ISetFetchedCustomers {
	type: EditCategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		customers: IItemForGetShortInfo[];
	};
}

interface ISetIDCustomer {
	type: EditCategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: Nullable<string>;
	};
}

interface ISetFetchedRestaurants {
	type: EditCategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		restaurants: IItemForGetShortInfo[];
	};
}

interface ISetIDRestaurant {
	type: EditCategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: string[];
	};
}

interface IChangeNameOfCategory {
	type: EditCategoryActionTypes.CHANGE_NAME_OF_CATEGORY;
	payload: {
		nameOfCategory: string;
	};
}

interface ISetCategoryType {
	type: EditCategoryActionTypes.SET_CATEGORY_TYPE;
	payload: {
		categoryType: Nullable<TCategoryType>;
	};
}

interface IToggleIsRestricted {
	type: EditCategoryActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IChangeActivationSchedule {
	type: EditCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: string;
	};
}

interface IChangeDeactivationSchedule {
	type: EditCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: string;
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditCategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	};
}

interface ISetTranslationTab {
	type: EditCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: Nullable<TLanguageIDs>;
	};
}

interface IChangeTranslation {
	type: EditCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IMenuTranslation[];
	};
}

interface ISetDataForSubmit {
	type: EditCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IUpdateCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: EditCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TEditCategoryAction =
	| IRefetchData
	| ISetInitialFormData
	| ISetAllData
	| IChangeLoaderStatus
	| IChangeVisibleForm
	| ISetFileId
	| IDeletePhoto
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDRestaurant
	| IChangeNameOfCategory
	| ISetCategoryType
	| IToggleIsRestricted
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
